// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import DistrictDTO from './DistrictDTO';
import SecondaryCipNumberDTO from './SecondaryCipNumberDTO';
import InstitutionCourseDTO from './InstitutionCourseDTO';
import InstitutionDTO from './InstitutionDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface EducationProgramReportDataTableProviderDTO extends EntitySelectorDTO { 
	id: string | null;
	secondaryProgramId: number;
	districtId: string | null;
	district: DistrictDTO | null;
	cipNumberId: string | null;
	secondaryCipNumber: SecondaryCipNumberDTO | null;
	programStartYear: number | null | null;
	programEndYear: number | null | null;
	secondaryCourseId: number;
	academicYear: number;
	enrollment: number;
	localCourseNumber: string | null;
	courseName: string | null;
	institutionCourseId: string | null | null;
	institutionCourse: InstitutionCourseDTO | null;
	carnegieUnit: number;
	communityCollegeIdentifier: number;
	communityCollegeId: string | null | null;
	communityCollege: InstitutionDTO | null;
	sced: string | null;
}

const EducationProgramReportDataTableProviderDTO = {
    className: 'EducationProgramReportDataTableProviderDTO',
    create: (initValues?: Partial<EducationProgramReportDataTableProviderDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			secondaryProgramId: 0,
			districtId: '00000000-0000-0000-0000-000000000000',
			district: null,
			cipNumberId: '00000000-0000-0000-0000-000000000000',
			secondaryCipNumber: null,
			programStartYear: null,
			programEndYear: null,
			secondaryCourseId: 0,
			academicYear: 0,
			enrollment: 0,
			localCourseNumber: "",
			courseName: "",
			institutionCourseId: null,
			institutionCourse: null,
			carnegieUnit: 0,
			communityCollegeIdentifier: 0,
			communityCollegeId: null,
			communityCollege: null,
			sced: "",
        },
        initValues);
    },
	id: 'id',
	secondaryProgramId: 'secondaryProgramId',
	districtId: 'districtId',
	district: 'district',
	cipNumberId: 'cipNumberId',
	secondaryCipNumber: 'secondaryCipNumber',
	programStartYear: 'programStartYear',
	programEndYear: 'programEndYear',
	secondaryCourseId: 'secondaryCourseId',
	academicYear: 'academicYear',
	enrollment: 'enrollment',
	localCourseNumber: 'localCourseNumber',
	courseName: 'courseName',
	institutionCourseId: 'institutionCourseId',
	institutionCourse: 'institutionCourse',
	carnegieUnit: 'carnegieUnit',
	communityCollegeIdentifier: 'communityCollegeIdentifier',
	communityCollegeId: 'communityCollegeId',
	communityCollege: 'communityCollege',
	sced: 'sced',
};

export default EducationProgramReportDataTableProviderDTO;